import React from 'react';

import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuTypePropType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuItemGroup } from 'ui-components/components/dropdown-menu-item-group';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { noop } from 'ui-components/default-props/noop';
import { testId } from 'ui-components/services/testid-service';
import { ShippingServiceGroupPropType } from './prop-types';
import { messages } from '../../fulfillment-planner/messages';
import { MessageDescriptorPropType } from '../../prop-types/intl';
import { ShippingStrategyDefaultTagWithName } from '../shipping-strategy-default-tag/shipping-strategy-default-tag-with-name';
import { emptyArray } from 'ui-components/default-props/empty';

export const ShippingServiceSelector = ({
  id,
  dropdownMenuType,
  onSelected = noop,
  serviceGroups = emptyArray,
  variant = 'form',
  defaultEmptyText,
  className = '',
  dropdownTogglerClassName = '',
  hasError = false,
  selectedItemName = '',
  dropdownMenuShouldHaveWidthOfButton = false,
  hasLabelOverFlow = false,
  shouldHaveFullWidth = true,
}) => {
  const intl = useIntl();
  const filteredGroups = serviceGroups.filter((group) => !!group).filter((group) => group.items.length > 0);
  const emptyText = defaultEmptyText ? (
    <FormattedMessage {...defaultEmptyText} />
  ) : (
    <FormattedMessage {...messages.defaultSelectServicePlaceholder} />
  );

  return (
    <DropdownMenu
      className={className}
      dropdownMenuShouldHaveWidthOfButton={dropdownMenuShouldHaveWidthOfButton}
      dropdownMenuType={dropdownMenuType}
      fullWidth={shouldHaveFullWidth}
      id={id}
      variant={variant}
      {...testId('csw-shipping-service')}
      ariaLabel={intl.formatMessage(messages.shippingService)}
    >
      <DropdownMenuToggler className={dropdownTogglerClassName} hasError={hasError}>
        {selectedItemName || emptyText}
      </DropdownMenuToggler>
      <DropdownMenuItem onClick={() => onSelected({})} selected={!selectedItemName}>
        {emptyText}
      </DropdownMenuItem>
      {filteredGroups.map((serviceGroup, index) => {
        const { groupId, groupClassname = '', items, name } = serviceGroup;
        const groupLabel = typeof name === 'string' ? name : intl.formatMessage(name, name?.values);
        return (
          <DropdownMenuItemGroup
            key={groupId}
            className={groupClassname}
            hasLabelOverFlow={hasLabelOverFlow}
            index={index}
            label={groupLabel}
          >
            {items.map((item) => (
              <DropdownMenuItem
                key={`${groupId}-${item.serviceId || item.serviceCollectionGuid}`}
                disabled={item.disabled}
                name={item}
                onClick={() => onSelected({ ...item, groupId })}
                selected={item.selected}
              >
                {!item.isTemplate ? item.name : <ShippingStrategyDefaultTagWithName name={item.name} />}
              </DropdownMenuItem>
            ))}
          </DropdownMenuItemGroup>
        );
      })}
    </DropdownMenu>
  );
};

ShippingServiceSelector.propTypes = {
  id: PropTypes.string,
  dropdownMenuType: DropdownMenuTypePropType,
  selectedItemName: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onSelected: PropTypes.func,
  variant: PropTypes.oneOf(['button', 'form']),
  defaultEmptyText: MessageDescriptorPropType,
  className: PropTypes.string,
  dropdownTogglerClassName: PropTypes.string,
  hasError: PropTypes.bool,
  serviceGroups: PropTypes.arrayOf(ShippingServiceGroupPropType),
  dropdownMenuShouldHaveWidthOfButton: PropTypes.bool,
  hasLabelOverFlow: PropTypes.bool,
  shouldHaveFullWidth: PropTypes.bool,
};
